import { render, staticRenderFns } from "./ModernComarcaSelect.vue?vue&type=template&id=1b996e18&"
import script from "./ModernComarcaSelect.vue?vue&type=script&lang=js&"
export * from "./ModernComarcaSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports